import React from 'react'
import { Helmet } from 'react-helmet'
import { Layout } from '../layout'
import { HomeHero, HomeAbout, HomeClients, HomeService, HomeWhy, HomeProject, HomeAction } from '../container'

const Home = () => {
  return (
    <Layout>
      <Helmet>
        <title>Shopify Design and Development – Robert Eberhard</title>
      </Helmet>
      <HomeHero />
      <HomeAbout />
      <HomeClients />
      <HomeWhy />
      <HomeService />
      <HomeProject />
      <HomeAction />
    </Layout>
  )
}

export default Home
